import React, { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ProblemSection } from './components/ProblemSection';
import { TransitionSection } from './components/TransitionSection';
import { ProductPresentation } from './components/ProductPresentation';
import { BonusSection } from './components/BonusSection';
import { ProductPack } from './components/ProductPack';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Button } from './components/ui/Button';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel (wrapped in try-catch for sandbox environments)
    try {
      const options = {
        autoConfig: true,
        debug: false
      };
      ReactPixel.init('1322033292727002', undefined, options);
      ReactPixel.pageView();
    } catch (e) {
      // Meta Pixel may fail in preview/sandbox environments - works fine when deployed
      console.warn('Meta Pixel initialization skipped:', e);
    }
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] text-[#3D2B1F] font-sans selection:bg-[#D4850A] selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TransitionSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ProductPack data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />

        {/* Final CTA Section */}
        <section className="py-20 px-4 text-center border-t border-[#E8D5C4]" data-id="element-15">
          <div className="max-w-3xl mx-auto" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#3D2B1F]" data-id="element-17">
              🛒 Descárgalo ahora
            </h2>
            <p className="text-xl text-[#6B5344] mb-4" data-id="element-18">
              Haz clic en el botón y accede inmediatamente al recetario.
            </p>
            <p className="text-lg text-[#9B8578] mb-10" data-id="element-19">
              En pocos minutos podrás empezar a preparar budines caseros
              deliciosos y fáciles.
            </p>
            <Button href="http://checkout.sabores365.online/cart/59169162362961:1" size="xl" className="mb-6 w-full md:w-auto" data-id="element-20">
              👉 Descargar ahora el recetario
            </Button>
            <p className="text-sm text-[#9B8578] mb-8 flex items-center justify-center gap-2" data-id="element-21">
              🔒 Pago seguro · Garantía 45 días · Acceso inmediato
            </p>
            <div className="flex justify-center" data-id="element-22">
              <CountdownTimer size="sm" data-id="element-23" />
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-[#FEF3E2] border-t border-[#E8D5C4] py-8 text-center text-[#9B8578] text-sm" data-id="element-24">
        <p data-id="element-25">
          © {new Date().getFullYear()} Budines Irresistibles. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs" data-id="element-26">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <PurchasePopup data-id="element-27" />
    </div>;
}